import type { OtpChannel } from 'services/payex/otp/types';

const FIFTEEN_MIN_IN_MS = 15 * 60 * 1000;

type OtpSendKey = {
  email: string;
  phone?: string;
  context: string;
  channel: OtpChannel;
};

type OtpSendCacheEntry = OtpSendKey & { timestamp: number };

let lastOtpSent: OtpSendCacheEntry | null = null;

const clear = () => {
  lastOtpSent = null;
};

export const otpSendCache = {
  wasRecentlySent: ({ email, phone, context, channel }: OtpSendKey) => {
    const now = Date.now();
    return Boolean(
      lastOtpSent &&
        lastOtpSent.email === email &&
        lastOtpSent.phone === phone &&
        lastOtpSent.context === context &&
        lastOtpSent.channel === channel &&
        now - lastOtpSent.timestamp < FIFTEEN_MIN_IN_MS,
    );
  },
  record: ({ email, phone, context, channel }: OtpSendKey) => {
    lastOtpSent = { email, phone, context, channel, timestamp: Date.now() };
  },
  clear,
  reset: clear,
};

export type { OtpSendKey };
